export default "<body>\r\n\r\n  <router-outlet></router-outlet>\r\n\r\n</body>\r\n";